/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthorAttributions } from './AuthorAttributions';
import {
    AuthorAttributionsFromJSON,
    AuthorAttributionsFromJSONTyped,
    AuthorAttributionsToJSON,
    AuthorAttributionsToJSONTyped,
} from './AuthorAttributions';

/**
 * 
 * @export
 * @interface Photos
 */
export interface Photos {
    /**
     * 
     * @type {string}
     * @memberof Photos
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Photos
     */
    widthPx?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Photos
     */
    heightPx?: number | null;
    /**
     * 
     * @type {Array<AuthorAttributions>}
     * @memberof Photos
     */
    authorAttributions?: Array<AuthorAttributions> | null;
    /**
     * 
     * @type {string}
     * @memberof Photos
     */
    flagContentUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Photos
     */
    googleMapsUri?: string | null;
}

/**
 * Check if a given object implements the Photos interface.
 */
export function instanceOfPhotos(value: object): value is Photos {
    return true;
}

export function PhotosFromJSON(json: any): Photos {
    return PhotosFromJSONTyped(json, false);
}

export function PhotosFromJSONTyped(json: any, ignoreDiscriminator: boolean): Photos {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'widthPx': json['widthPx'] == null ? undefined : json['widthPx'],
        'heightPx': json['heightPx'] == null ? undefined : json['heightPx'],
        'authorAttributions': json['authorAttributions'] == null ? undefined : ((json['authorAttributions'] as Array<any>).map(AuthorAttributionsFromJSON)),
        'flagContentUri': json['flagContentUri'] == null ? undefined : json['flagContentUri'],
        'googleMapsUri': json['googleMapsUri'] == null ? undefined : json['googleMapsUri'],
    };
}

export function PhotosToJSON(json: any): Photos {
    return PhotosToJSONTyped(json, false);
}

export function PhotosToJSONTyped(value?: Photos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'widthPx': value['widthPx'],
        'heightPx': value['heightPx'],
        'authorAttributions': value['authorAttributions'] == null ? undefined : ((value['authorAttributions'] as Array<any>).map(AuthorAttributionsToJSON)),
        'flagContentUri': value['flagContentUri'],
        'googleMapsUri': value['googleMapsUri'],
    };
}

